import { v4 as uuid } from 'uuid';

export default class User {
  constructor(Vue) {
    this.portal = Vue.prototype.$portal;
    this.cookies = Vue.prototype.$cookies;
    this.utils = Vue.prototype.$utils;
    this.company = Vue.prototype.$company;
    this.init();
    this.vue = Vue;
  }

  init() {
    this.json = '';
    this.selectedEntity = [];

    this.selectedEntityLoaded = [];
    this.entityPendingApproval = [];

    this.isSelectedDiff = false;
    this.hasEntity = false;
    this.hasEntitySelected = false;
    this.isLoginByTokenLoading = false;
    this.token = '';
    this.email = '';
    this.name = '';
    this.isPublic = false;
    this.isLoadingValidateSession = false;
    this.availableModules = '';
    this.isLdapUser = false;
    this.isAdfsUser = false;
    this.hasAccountsAccess = false;
  }

  loadFromLogin(json, token, entity = [], isPublic = false, isLoadSum = true) {
    return new Promise((resolve, reject) => {
      json.firstNick = json.nick.split(' ')[0];
      this.json = json;

      this.lockProperty(this.json, 'email', json.email);
      Object.freeze(this.json.groups);

      this.selectedEntity.splice(0);
      this.selectedEntityLoaded.splice(0);

      json.entitySelected.forEach(i => {
        this.selectedEntity.push(i);
        this.selectedEntityLoaded.push(i);
      });

      if (
        Array.isArray(this.selectedEntity)
        && this.selectedEntity.length > 0
      ) this.hasEntitySelected = true;

      if (
        this.hasEntitySelected
        || (
          Array.isArray(entity)
          && entity.length > 0
        )
      ) this.hasEntity = true;
      else this.hasEntity = false;

      this.token = token;
      this.isPublic = isPublic;

      const hasPendingTerms = Object.keys(this.json.pendingTerms || {}).length > 0;

      if (this.hasEntitySelected && isLoadSum && !hasPendingTerms) this.company.reloadSumValue();

      if (this.company.isEntityApproval()) this.loadEntityPendingApproval();
      return resolve();
    });
  }

  lockProperty(obj, name, value) {
    Object.defineProperty(obj, name, { value, writable: false });
  }

  setToken(token) {
    this.token = token;
  }

  loadEntityPendingApproval() {
    this.utils.accessCore.loadEntityPendingApproval()
      .then(res => {
        this.entityPendingApproval = res;
      });
  }

  isLogged() {
    if (this.json && this.token)
      return true;

    return false;
  }

  logout() {
    if (this.company.itemScriptLoading) return;
    /** Fecha os scripts @legacy */
    brain.closeScript();

    this.init();

    if (localStorage.getItem('code') && _.get(this.company.json, 'chat.type')) {
      this.cookies.remove('code');
      localStorage.removeItem('code');
      brain.closeChat();
    } else {
      this.cookies.remove('code');
      localStorage.removeItem('code');
    }
  }

  clear() {
    this.init();
  }

  getAvailableModules() {
    if (this.availableModules) return this.availableModules;

    const modules = _.get(this.company, 'json.module', []);
    const { groups } = this.json || {};

    this.availableModules = modules.filter(module => {
      const moduleGroups = _.get(module, 'role.groups');

      if (!moduleGroups || moduleGroups.length === 0)
        return this.getAvailableModuleItems(module).length > 0;

      const hasModuleGroup = moduleGroups.find(i => groups.includes(i));

      if (hasModuleGroup) return this.getAvailableModuleItems(module).length > 0;

      return false;
    });

    return this.availableModules;
  }

  getAvailableModuleItems(module) {
    const items = _.get(module, 'item', []);
    const { groups } = this.json || {};

    return items.filter(item => {
      const itemGroups = _.get(item, 'groups');

      if (!itemGroups) return true;

      const hasItemGroup = itemGroups.find(i => groups.includes(i));

      return hasItemGroup;
    });
  }


  /**
   * SE PASSAR UM NAME, RETORNA O FIRST DO MESMO
   * SE NÃO RETORNA O DO JSON
   */
  getFirstNick(name) {
    if (name) return name.split(' ')[0];
    if (!this.json || !this.json.nick) return '';
    return this.json.nick.split(' ')[0];
  }

  selectedDiff() {
    if (
      this.hasEntity
      && !this.hasEntitySelected
    ) return true;

    const valid1 = [];
    const valid2 = [];

    // eslint-disable-next-line curly
    for (let i = 0; i <= this.selectedEntity.length; i++) {
      if (_.has(this.selectedEntity[i], 'code')) valid1.push(this.selectedEntity[i].code.toString());
    }

    // eslint-disable-next-line curly
    for (let i = 0; i <= this.selectedEntityLoaded.length; i++) {
      if (_.has(this.selectedEntityLoaded[i], 'code')) valid2.push(this.selectedEntityLoaded[i].code.toString());
    }

    if (
      _.difference(valid1, valid2).length > 0
      || _.difference(valid2, valid1).length > 0
    ) return true;

    return false;
  }

  /**
   * LoginByToken
   */
  async loginByToken() {
    try {
      if (this.isLoginByTokenLoading) return;
      this.isLoginByTokenLoading = true;

      const obj = {};

      const { token, json, isPublic } = await this.validateSession();

      if (isPublic) throw '#PUBLIC_SESSION';

      this.token = token;
      obj.user = _.get(json, 'user');
      const [userData, entityData] = await Promise.all([
        this.utils.authCore.getUserData(obj.user.email),
        this.utils.accessCore.listEntityByUser({ limit: 1 }),
      ]);

      obj.user = Object.assign({}, obj.user, userData);
      obj.entity = entityData;

      await this.loadFromLogin(obj.user, token, obj.entity);

      this.isLoginByTokenLoading = false;
    } catch (err) {
      this.isLoginByTokenLoading = false;
      console.error('#ERRO_LOGIN_BY_TOKEN', err);
      throw new Error('#ERRO_LOGIN_BY_TOKEN');
    }
  }

  /**
   * loginPublic
   */
  async loginPublic() {
    try {
      this.token = atob(localStorage.getItem('code')) || uuid();
      this.json = {
        id: this.company.json.id,
      };

      this.cookies.set('code', this.token);

      this.isPublic = true;
    } catch (err) {
      // console.error('#ERRO_LOGIN_PUBLIC', err);
      throw new Error('#ERRO_LOGIN_PUBLIC');
    }
  }

  getUserGeolocation() {
    return new Promise(resolve => {
      if (!navigator.geolocation) return resolve({});

      console.log('Geolocation is supported!');

      let startPos;

      const onSuccess = position => {
        startPos = position;
        const { latitude, longitude } = startPos.coords;

        this.json.geolocation = {
          latitude,
          longitude,
        };

        return resolve(this.json.geolocation);
      };

      const onError = error => {
        // error.code can be:
        //   0: unknown error
        //   1: permission denied
        //   2: position unavailable (error response from location provider)
        //   3: timed out
        console.log(`Error occurred. Error code: ${error.code}`);

        return resolve({});
      };

      // ? It'll ask the user's permission
      navigator.geolocation.getCurrentPosition(onSuccess, onError, {
        timeout: 10 * 1000,
        maximumAge: 5 * 60 * 1000,
      });
    });
  }

  async validateSession() {
    try {
      const storedToken = atob(localStorage.getItem('code'));
      const token = (this.token) ? this.token : storedToken;

      if (!token) throw { status: 401 };

      this.isLoadingValidateSession = true;

      const {
        isPublic, json, isLdapUser, isAdfsUser,
      } = await this.utils.authCore.sessionValidate(token);

      this.isLdapUser = isLdapUser;
      this.isAdfsUser = isAdfsUser;
      this.isLoadingValidateSession = false;
      return { token, json, isPublic };
    } catch (err) {
      this.isLoadingValidateSession = false;
      console.error('Error - validateSession', err);
      throw { status: 401, code: '#INVALID_SESSION', message: 'Unauthorized' };
    }
  }

  toggleCnpj(blockError) {
    if (
      (!this.selectedDiff() || this.selectedEntity.length === 0)
      && !blockError
    ) {
      return brain.swal({
        text: 'Você precisa selecionar no mínimo 1 empresa!',
        type: 'warning',
      });
    }
    if (this.selectedEntity.length === 0) return;

    // this.utils.proCore.toggleCnpj()
    this.utils.authCore.updateEntitySelected()
      .then(() => {
        this.selectedEntityLoaded.splice(0);
        this.selectedEntity.forEach(i => {
          this.selectedEntityLoaded.push(i);
        });

        this.loginByToken();
        brain.closeModule();
      })
      .catch(err => {
        console.error('Error toggleCnpj', err);
      });
  }

  getTermUrl({ pendingTerms = {} } = {}) {
    const [termId, { version }] = Object.entries(pendingTerms).pop();

    return `/termos/${termId}/${encodeURIComponent(version)}`;
  }

  removePendingTerm({ termId = '' }) {
    delete this.json.pendingTerms[termId];
  }

  findGroup(group) {
    if (_.findKey(this.json.groups, i => i.toLowerCase() == group.toLowerCase())) return true;
    return false;
  }

  isAdapcon() {
    if (_.has(this.json, 'email') && this.json.email.includes('@adapcon.com.br')) return true;
    return false;
  }

  isAdapconGroup() {
    const groups = _.get(this.json, 'groups');

    if (groups && groups.includes('adapcon')) return true;
    return false;
  }

  openFeedback() {
    brain.openFeedback();
  }

  hasNotificationsSettings(type) {
    if (!this.json.notifications)
      return false;

    if (type)
      return !!this.json.notifications?.[type]?.status;

    const hasNotifications = Object.keys(this.json.notifications).some(item => this.json.notifications[item].status === true);

    return hasNotifications;
  }

  async hasAccountsModuleAccess() {
    if (this.hasAccountsAccess) return true;

    const hasAccess = await this.utils.accountsModule.hasAccountsModuleAccess();
    console.log(hasAccess);
    this.hasAccountsAccess = hasAccess;

    return hasAccess;
  }
}
